   /* Bryan jQuery */
  $(document).ready(function() {
   
    const networkCameras = $("#Slide-template--21312313557278__9a5b96c2-f8ac-4206-8d38-c19e97dcaa0f-1");
    const dvr = $("#Slide-template--21312313557278__9a5b96c2-f8ac-4206-8d38-c19e97dcaa0f-2");
    const analogCameras = $("#Slide-template--21312313557278__9a5b96c2-f8ac-4206-8d38-c19e97dcaa0f-3");
    const router = $("#Slide-template--21312313557278__9a5b96c2-f8ac-4206-8d38-c19e97dcaa0f-4");
    const switchdev = $("#Slide-template--21312313557278__9538c8eb-e81f-4507-bcd6-a026ded6dae2-1");
    const wifi = $("#Slide-template--21312313557278__9538c8eb-e81f-4507-bcd6-a026ded6dae2-2");
    const cable = $("#Slide-template--21312313557278__9538c8eb-e81f-4507-bcd6-a026ded6dae2-3");
    const tools = $("#Slide-template--21312313557278__9538c8eb-e81f-4507-bcd6-a026ded6dae2-4");

    /* Event Listener */
    networkCameras.on("click", function(e) {
      e.preventDefault();
      // Redirect to the specified link
      window.location.href = "https://cctvops.com/collections/network-cameras";
      console.log("Test Bryan Click!!!");
    });

    dvr.on("click", function(e) {
      e.preventDefault();
      // Redirect to the specified link
      window.location.href = "https://cctvops.com/collections/dvr";
      console.log("Test Bryan Click!!!");
    });

    analogCameras.on("click", function(e) {
      e.preventDefault();
      // Redirect to the specified link
      window.location.href = "https://cctvops.com/collections/analog-cameras";
      console.log("Test Bryan Click!!!");
    });

    router.on("click", function(e) {
      e.preventDefault();
      // Redirect to the specified link
      window.location.href = "https://cctvops.com/collections/router";
      //console.log("Test Bryan Click!!!");
    });

    switchdev.on("click", function(e) {
      e.preventDefault();
      // Redirect to the specified link
      window.location.href = "https://cctvops.com/collections/switch";
    });

    wifi.on("click", function(e) {
      e.preventDefault();
      // Redirect to the specified link
      window.location.href = "https://cctvops.com/collections/wifi";
    });

    cable.on("click", function(e) {
      e.preventDefault();
      // Redirect to the specified link
      window.location.href = "https://cctvops.com/collections/cable";
    });

    tools.on("click", function(e) {
      e.preventDefault();
      // Redirect to the specified link
      window.location.href = "https://cctvops.com/collections/tools";
    });
  });
        /* Bry Vanilla JS */
       /* const networkCameras = document.getElementById("Slide-template--21312313557278__9a5b96c2-f8ac-4206-8d38-c19e97dcaa0f-1");
        const dvr = document.getElementById("Slide-template--21312313557278__9a5b96c2-f8ac-4206-8d38-c19e97dcaa0f-2");
        const analogCameras = document.getElementById("Slide-template--21312313557278__9a5b96c2-f8ac-4206-8d38-c19e97dcaa0f-3");
        const router = document.getElementById("Slide-template--21312313557278__9a5b96c2-f8ac-4206-8d38-c19e97dcaa0f-4");
        const switchdev = document.getElementById("Slide-template--21312313557278__9538c8eb-e81f-4507-bcd6-a026ded6dae2-1");
        const wifi = document.getElementById("Slide-template--21312313557278__9538c8eb-e81f-4507-bcd6-a026ded6dae2-2");
        const cable = document.getElementById("Slide-template--21312313557278__9538c8eb-e81f-4507-bcd6-a026ded6dae2-3");
        const tools = document.getElementById("Slide-template--21312313557278__9538c8eb-e81f-4507-bcd6-a026ded6dae2-4");*/


        /*Event Listener*/
     /*   networkCameras.addEventListener("click", (e) =>{
        event.preventDefault();
        // Redirect to the specified link
        window.location.href = "https://cctvops.com/collections/network-cameras";
        console.log("Click!!!");
        })

        dvr.addEventListener("click", (e) =>{
        event.preventDefault();
        // Redirect to the specified link
        window.location.href = "https://cctvops.com/collections/dvr";
        console.log("Click!!!");
        })

        analogCameras.addEventListener("click", (e) =>{
        event.preventDefault();
        // Redirect to the specified link
        window.location.href = "https://cctvops.com/collections/analog-cameras";
        console.log("Click!!!");
        })

        router.addEventListener("click", (e) =>{
        event.preventDefault();
        // Redirect to the specified link
        window.location.href = "https://cctvops.com/collections/router";
        //console.log("Click!!!");
        })

        switchdev.addEventListener("click", (e) =>{
        event.preventDefault();
        // Redirect to the specified link
        window.location.href = "https://cctvops.com/collections/switch";
     
        })

        wifi.addEventListener("click", (e) =>{
        event.preventDefault();
        // Redirect to the specified link
        window.location.href = "https://cctvops.com/collections/wifi";
       
        })

        cable.addEventListener("click", (e) =>{
        event.preventDefault();
        // Redirect to the specified link
        window.location.href = "https://cctvops.com/collections/cable";
     
        })

        tools.addEventListener("click", (e) =>{
        event.preventDefault();
        // Redirect to the specified link
        window.location.href = "https://cctvops.com/collections/tools";
       
        })*/
